import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ListReleaseIssuesRequest, ListReleaseIssuesResponse, ProductName, ReleaseIssue, ReleaseIssueCategory, ReleaseIssuePriority, ReleaseIssueStatus, SituViewWebApiClient } from 'situview-webapi-client';
import { ReleaseIssueDialogComponent } from '../release-issue-dialog/release-issue-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Utils } from 'src/app/services';

@Component({
  selector: 'release-issue-list',
  templateUrl: './release-issue-list.component.html',
  styleUrls: ['./release-issue-list.component.scss']
})
export class ReleaseIssueListComponent implements OnInit {
  @Input() companyId: string | undefined;
  @Input() hideEdit: boolean = true;
  @Input() hideReport: boolean = true;
  @Input() isSituUser: boolean = false;
  @Input() isSelectable: boolean = false;
  @Input() displayLength: number = 3;
  @Input() selectedReleaseIssue: string | undefined;
  @Input() productName: ProductName | undefined;
  @Output() onSelectClick: EventEmitter<string> = new EventEmitter();
  @Output() onIssueSelectClick: EventEmitter<string> = new EventEmitter();

  constructor(
    private situViewApiClient: SituViewWebApiClient,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loadReleaseIssues();
  }

  searchReleaseIssuesField = new FormControl();
  releaseIssues: ReleaseIssue[] = [];
  filteredReleaseIssues: ReleaseIssue[] | undefined;
  confirmedNewIssue: boolean = false;
  releaseIssueStatuses = ReleaseIssueStatus;
  releaseIssuePriorities = ReleaseIssuePriority;
  releaseIssueCategories = ReleaseIssueCategory;
  
  private loadReleaseIssues() {
    if (!this.companyId) {
      this.showMessage("Company is required to fetch Release Issues!")
      return;
    }
    let request = new ListReleaseIssuesRequest();
    request.companyId = this.companyId;
    request.includeStats = true;
    if (this.productName !== undefined) request.productName = this.productName;

    this.situViewApiClient.listReleaseIssues(request)
      .then((response: ListReleaseIssuesResponse) => {
        if (response.success && response.items) {
          this.releaseIssues = response.items;
          this.filteredReleaseIssues = [...this.releaseIssues];
          if (this.selectedReleaseIssue) {
            this.filteredReleaseIssues = this.filteredReleaseIssues.filter(x => x.id === this.selectedReleaseIssue);
           // this.selectedCard = this.selectedReleaseIssue;
          }
        }
      })
      .catch((err: any) => {

      })
      .finally(() => {
        //this.loading = false;
      });
  }
  doReleaseIssueFilter = (value: string = '') => {
    const searchTerm = value.trim().toLowerCase();
  
    this.filteredReleaseIssues = this.releaseIssues?.filter((issue) => {
      const matchesSearch = 
        issue.description?.toLowerCase().includes(searchTerm) || 
        issue.title?.toLowerCase().includes(searchTerm) ||
        issue.createdByName?.toLowerCase().includes(searchTerm) ||
        issue.assignedToName?.toLowerCase().includes(searchTerm);
      const matchesPriority = !this.priorityFilter || issue.releaseIssuePriority === this.priorityFilter;
      const matchesStatus = !this.statusFilter || issue.releaseIssueStatus === this.statusFilter;
      const matchesCreated = !this.createdFilter || issue.createdByName === this.createdFilter;
      const matchesAssigned = !this.assignedFilter || issue.assignedToName === this.assignedFilter;
  
      return matchesSearch && (matchesPriority && matchesStatus && matchesCreated && matchesAssigned);
    });
  };

  getPriority(releaseIssuePriority: ReleaseIssuePriority | undefined) {
    switch(releaseIssuePriority) {
      case ReleaseIssuePriority.High:
        return "Blocker";
      case ReleaseIssuePriority.Medium:
        return "Medium";
      default: 
        return "Low";
    }
  }

  getCategory(releaseIssueCategory: ReleaseIssueCategory | undefined) {
    switch(releaseIssueCategory) {
      case ReleaseIssueCategory.Theming:
        return "Style / Theme";
      case ReleaseIssueCategory.Drawing:
        return "Home Plan";
      default: 
        return "Software";
    }
  }

  releaseIssueDialogRef: MatDialogRef<ReleaseIssueDialogComponent> | undefined;
  onEdit(releaseIssueId?: string) {
    this.releaseIssueDialogRef = this.dialog.open(ReleaseIssueDialogComponent, {
      panelClass: 'modal-panel',
      width: '60%',
      height: '80%',
      data: {
        isSituUser: this.isSituUser,
        companyId: this.companyId,
        releaseIssueId: releaseIssueId
      }
    });
  }
  selectedCard: string | undefined;
  onCardSelectClick(releaseIssueId: string | undefined) { 
    if (releaseIssueId !== this.selectedCard) {
      this.selectedCard = releaseIssueId;
    } else {
      this.selectedCard = undefined;
    }
    this.onSelectClick.emit(releaseIssueId);
  }
  priorityFilter: ReleaseIssuePriority | undefined;
  onCardPriorityClick(releaseIssuePriority: ReleaseIssuePriority | undefined) { 
    if (releaseIssuePriority !== this.priorityFilter) {
      this.priorityFilter = releaseIssuePriority;
      this.doReleaseIssueFilter(this.searchReleaseIssuesField.value || '');
    }
  }
  statusFilter: ReleaseIssueStatus | undefined;
  onCardStatusClick(releaseIssueStatus: ReleaseIssueStatus | undefined) { 
    if (releaseIssueStatus !== this.statusFilter) {
      this.statusFilter = releaseIssueStatus;
      this.doReleaseIssueFilter(this.searchReleaseIssuesField.value || '');
    }
  }
  createdFilter: string | undefined;
  onCardCreatedClick(created: string | undefined) { 
    if (created !== this.createdFilter) {
      this.createdFilter = created;
      this.doReleaseIssueFilter(this.searchReleaseIssuesField.value || '');
    }
  }
  assignedFilter: string | undefined;
  onCardAssignedClick(assigned: string | undefined) { 
    if (assigned !== this.assignedFilter) {
      this.assignedFilter = assigned;
      this.doReleaseIssueFilter(this.searchReleaseIssuesField.value || '');
    }
  }
  //assignedFilter: string | undefined;
  onCardIssueLoadClick(issueUrl: string | undefined) { 
    if (issueUrl) {
      this.onIssueSelectClick.emit(issueUrl);
    }
  }
  clearFocusFilter() {
    this.selectedReleaseIssue = undefined;
    this.doReleaseIssueFilter(this.searchReleaseIssuesField.value || '');
    //this.selectedCard = undefined;
    this.onSelectClick.emit(undefined);
  }

  downloadCSV() {
    if (!this.filteredReleaseIssues) {
      return;
    }

    const csvData = this.convertToCSV(this.filteredReleaseIssues);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const timestamp = Utils.getCurrentTimestamp();
    const fileName = `release_issues_${timestamp}.csv`;

    // For IE 11
    if ((navigator as any).msSaveBlob) {
      (navigator as any).msSaveBlob(blob, fileName);
    } else {
      // Modern browsers
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  private convertToCSV(releaseItems: ReleaseIssue[]): string {
    let str = '';
    let row = '';

    const headers = ['Title', 'Description', 'Status', 'Priority', 'Category', 'Created', 'Created By', 'Assigned To'];
    row = headers.join(',') + '\r\n';
    str += row;

    releaseItems.forEach((item: ReleaseIssue) => {
      let line = '';
      line += `${item.title},`;
      line += `${item.description},`;
      line += `${this.releaseIssueStatuses[item?.releaseIssueStatus ?? 1]},`;
      line += `${this.getPriority(item?.releaseIssuePriority)},`;
      line += `${this.getCategory(item?.releaseIssueCategory)},`;
      line += `${item?.dateCreated},`;
      line += `${item?.createdByName ?? ""},`;
      line += `${item?.assignedToName ?? ""},`;
      str += line + '\r\n';
    });

    return str;
  }

  showMessage(message: string) {
    this.snackBar.open(message, 'Dismiss', {
      duration: 3000
    });
  }
}